import { useTranslation } from "react-i18next";
import { useLocation, useParams } from "react-router-dom";
import { Breadcrumb } from "../../../../../components/ProductsLayout/SharedProductsLayout";
import { LinkUnstyled } from "../../../../../components/LinkUnstyled/LinkUnstyled";
import { PageWrapper } from "../../../../../layout/portalPageLayout";
import { ContentWrapper } from "../../../../../layout/publicPageLayout";
import { useRoutePath } from "../../../../../util/Routing";
import { useStoreState } from "../../../../../util/util";
import { useMdmEntityDisplayNames } from "../../../../../util/mdmEntityDisplayNames";
import { spacingTokens } from "../../../../../designTokens";
import { TemplatesNav, TemplatesNavWithPadding } from "./TemplatesNav";
import type { AttributeTemplateSchema } from "../../../../../types/types.PIM";
import type { TemplateLocationState } from "../../../../../types/types";
import useSWR from "swr";
import type { AxiosError } from "axios";
import { Activity } from "../../../../SharedPages/ProductDetailPage/Activity/Activity";

export function SellerAdminTemplateActivityTable() {
  const { t } = useTranslation();
  const { tenant_id } = useStoreState();
  const { getTemplateDisplayName } = useMdmEntityDisplayNames();
  const { adminPath } = useRoutePath();
  const { template_id } = useParams<{ template_id: string }>();
  const location = useLocation();

  const { data: template } = useSWR<AttributeTemplateSchema, AxiosError>(
    `/v2/tenants/${tenant_id}/pim/templates/${template_id}`
  );
  const templateDisplayName = getTemplateDisplayName(
    template ?? {},
    t("Template")
  );

  return (
    <PageWrapper>
      <Breadcrumb
        style={{ padding: `${spacingTokens.spacing_xl}`, paddingBottom: 0 }}
      >
        <LinkUnstyled
          to={{
            pathname: location.search.includes("from=dashboard")
              ? `${adminPath}/dashboard`
              : `${adminPath}/pim/templates`,
            state: {
              ...(location.state as TemplateLocationState),
              templateType:
                template?.template_type ??
                (location.state as TemplateLocationState)?.templateType,
            },
          }}
        >
          {location.search.includes("from=dashboard")
            ? t("Dashboard")
            : t("Templates")}
        </LinkUnstyled>
        <div>/</div>
        <div>{templateDisplayName}</div>
      </Breadcrumb>
      <TemplatesNavWithPadding
        style={{ marginBottom: spacingTokens.spacing_xl }}
      >
        <TemplatesNav
          pageTitle={templateDisplayName}
          tabIndex={3}
          templateID={template_id}
          enableCustomForms={template?.enable_custom_forms}
        />
      </TemplatesNavWithPadding>
      <ContentWrapper style={{ padding: `0 ${spacingTokens.spacing_xl}` }}>
        <Activity
          target_id={template_id}
          mode="template"
          hiddenColumns={["version_number", "status"]}
        />
      </ContentWrapper>
    </PageWrapper>
  );
}
